import classNames from "classnames";
import { range } from "lodash";
import { ActionIcon } from "PFComponents/action_icon";
import { Button } from "PFComponents/button";
import { CarouselBase, CarouselBaseProps } from "PFComponents/carousel/carousel_base";
import { useCarousel } from "PFComponents/carousel/use_carousel";
import React from "react";

import css from "./carousel.module.scss";

type CarouselProps = Pick<CarouselBaseProps, "items">;
type CarouselDotProps = {
  isActive: boolean;
  onClick: VoidFunction;
};

const CarouselDot = ({ isActive, onClick }: CarouselDotProps): JSX.Element => (
  <Button kind="blank" onClick={onClick} className={css.dotButton}>
    <div className={classNames(css.dot, { [css.active]: isActive })} />
  </Button>
);

const actionIconWidth = 32;
const columnGap = 8;
const iconSpaceWidth = actionIconWidth + columnGap;

export const Carousel = ({ items }: CarouselProps): JSX.Element => {
  const { activeIndex, canSlideLeft, canSlideRight, slideBack, slideForward, slideTo } = useCarousel({
    maxIndex: items.length - 1
  });

  return (
    <div className={css.verticalLayout}>
      <div
        className={css.horizontalLayout}
        style={{
          paddingLeft: canSlideLeft ? 0 : iconSpaceWidth,
          paddingRight: canSlideRight ? 0 : iconSpaceWidth
        }}
      >
        {canSlideLeft && (
          <ActionIcon name="chevron-left" size="md" color="paletteWhite0" onClick={slideBack} />
        )}
        <CarouselBase items={items} activeIndex={activeIndex} />
        {canSlideRight && (
          <ActionIcon name="chevron-right" size="md" color="paletteWhite0" onClick={slideForward} />
        )}
      </div>
      <div className={css.dots}>
        {range(items.length).map((index) => (
          <CarouselDot key={index} isActive={index === activeIndex} onClick={() => slideTo(index)} />
        ))}
      </div>
    </div>
  );
};
